import { Dispatch } from '@reduxjs/toolkit';
import { setSalesSteerings, setSearchedSalesSteerings, setSalesSteeringsLoading } from '../actions';
import { AppState } from '../store';

export function getSalesSteerings(percentage: number, duration: number): ReduxAction {
  return async (dispatch: Dispatch, getState: () => AppState) => {
    const {
      general: { appConfiguration, accessToken },
    } = getState();

    dispatch(setSalesSteeringsLoading(true));

    try {
      const request =
        `${appConfiguration.VITE_API_SALES_CONFIGURATION}/api/salesSteering?Percentage=${percentage}` +
        `&DurationMonths=${duration}`;

      const data = await fetch(request, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const SalesSteerings = await data.json();
      dispatch(setSalesSteerings(SalesSteerings));
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setSalesSteeringsLoading(false));
    }
  };
}

export function searchSalesSteerings(searchText: string, percentage: number, duration: number): ReduxAction {
  return async (dispatch: Dispatch, getState: () => AppState) => {
    const {
      general: { appConfiguration, accessToken },
    } = getState();

    if (typeof searchText !== 'string' || !searchText.trim()) {
      console.warn('searchSalesSteerings: Invalid searchText parameter:', searchText);
      dispatch(setSearchedSalesSteerings([]));
      return;
    }

    dispatch(setSalesSteeringsLoading(true));

    try {
      const request =
        `${appConfiguration.VITE_API_SALES_CONFIGURATION}/api/salesSteering/searchCondition/${searchText}` +
        `?Percentage=${percentage}` +
        `&DurationMonths=${duration}`;

      const data = await fetch(request, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const SalesSteerings = await data.json();

      dispatch(setSearchedSalesSteerings(SalesSteerings));
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setSalesSteeringsLoading(false));
    }
  };
}
